import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    datePicker: {
        borderRadius: "12px",
        backgroundColor: "white",
        transition: "0.20s",
        textAlign: "left",
        border: `1px solid ${theme.palette.secondary.main}`,
        "& fieldset": {
            border: "none",
        },
        "&:focus": {
            border: `1px solid ${theme.palette.secondary.main}`,
            boxShadow: `0 0 0 1px ${theme.palette.secondary.main}`,
        },
        "&:hover": {
            boxShadow: `0 0 0 0`,
            border: `1px solid ${theme.palette.primary.main}`,
        },
    },
    datePickerInput: {
        padding: "6px 10px 7px",
    },
}));
